import { useEffect, useState } from 'react';
import { collection, query, where } from 'firebase/firestore';
import { db } from '../../../firebase-client';
import { safeOnSnapshot } from '../../../utils/firestoreSubscriptions';

export function useQualificationRecords(teamId, memberId, enabled = false, allMembers = false) {
  const [today, setToday] = useState(() => new Date().toISOString().slice(0, 10));
  useEffect(() => {
    if (!enabled) return undefined;
    const timer = setInterval(() => setToday(new Date().toISOString().slice(0, 10)), 60000);
    return () => clearInterval(timer);
  }, [enabled]);
  const [records, setRecords] = useState([]), [loaded, setLoaded] = useState(false), [error, setError] = useState('');
  useEffect(() => {
    setRecords([]); setError('');
    if (!enabled || !teamId || (!memberId && !allMembers)) { setLoaded(true); return undefined; }
    setLoaded(false);
    const source = collection(db, 'teams', teamId, 'qualificationRecords');
    return safeOnSnapshot(allMembers ? source : query(source, where('memberId', '==', memberId)), snapshot => {
      setRecords(snapshot.docs.map(item => ({ ...item.data(), id: item.id }))); setLoaded(true);
    }, () => { setError('Unable to load qualification details. Please reopen the profile to try again.'); setLoaded(true); });
  }, [teamId, memberId, enabled, allMembers]);
  return { records, loaded, error, today };
}
